module.exports = __webpack_public_path__ + "img/gais.34e6da86.png";